module.exports = __webpack_public_path__ + "img/icon_map_188_off_110.a4023a93.png";